import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { InstantWinGroup, InstantWins } from '@core/models/raffle.model';
import { API_LIST } from '@core/services/web-api/api-list';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { MediaInfo, MediaType } from '@core/models/media-info.model';
import { GalleryDialogComponent } from '../gallery-dialog/gallery-dialog.component';

export class PageInfo {
  page: number | null;
  text: string;
}

@Component({
  selector: 'app-prize-card',
  templateUrl: './prize-card.component.html',
  styleUrls: ['./prize-card.component.scss'],
  animations: [
    trigger('toggleItem', [
      state('in', style({ height: '*' })),
      state('out', style({ height: '0' })),
      transition('in <=> out', animate('250ms ease'))
    ])
  ],
})

export class PrizeCardComponent implements OnChanges, OnInit {
  @Input() group: InstantWinGroup;
  @Input() closeCard: boolean;

  @ViewChild('ticketBoxRef') ticketBoxRef: ElementRef | undefined;
  @ViewChild('prizeCardHeadRef') prizeCardHeadRef: ElementRef | undefined;

  showBody = false;
  ticketGrid = 6;
  innerWidth = window.innerWidth;
  ticketWidth = window.innerWidth > 576 ? 142 : 94;
  showTickets = true;
  showDescription = false;
  tickets: InstantWins[];
  isLoading = true;
  limitPerPage = 96;
  showPagesNear = 1;
  totalEntries = 1;
  currentPage = 0;
  maxPage = 0;
  shownPageStart = 0;
  shownPageEnd = 0;
  pages: PageInfo[] = [];

  private _alive$ = new Subject<void>();

  constructor(
    private httpClient: HttpClient,
    public dialog: MatDialog,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {

    if (this.closeCard) {
      this.showBody = false;
    }

    if (this.group) {
      const domEL = document.createElement('div');
      domEL.innerHTML = this.group.description;
      this.showDescription = domEL.innerText.length > 2;
    }
  }

  ngOnAttach(): void {
   console.log('ngOnAttach');

  }

  ngOnDetach(): void {
    console.log('ngOnDetach');
  }

  ngOnInit(): void {
    fromEvent(window, 'resize').
    pipe(
      takeUntil(this._alive$),
    ).subscribe(() => {
      this.innerWidth = window.innerWidth;
      this.ticketWidth = window.innerWidth > 576 ? 142 : 94;
    });
  }

  toogleCard(): void {
    this.showBody = !this.showBody;
    if (!this.tickets) {
      this.loadTickets();
    }
  }

  loadTickets(): void {
    this.httpClient.get(API_LIST.getInstantWinTicketByGroup(this.group.id, this.currentPage * this.limitPerPage, this.limitPerPage),
      { observe: 'response' }).subscribe({
        next: (response: any) => {
          this.totalEntries = parseInt(response.headers.get('X-Count'), 10);

          if (isNaN(this.totalEntries) || this.totalEntries < 1) {
            this.totalEntries = 1;
          }

          this.tickets = response.body;
          this.ticketGrid = this.tickets.length > 36 ? Math.ceil(this.tickets.length / 6) : 6;
          this.calculatePagesInfo();
          this.isLoading = false;
        },

        error: (error) => {
          this.isLoading = false;
          console.error(error);
        }
      });
  }

  changePage(page): void {
    if (page < 1) {
      page = 0;
    }

    this.currentPage = page;
    this.calculatePagesInfo();
    this.loadTickets();

    if ( this.innerWidth > 992) {
      this.prizeCardHeadRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      this.ticketBoxRef.nativeElement.scrollTo({ left: 0,  behavior: 'smooth' });
    }

  }

  calculatePagesInfo(): void {
    this.maxPage = Math.ceil(this.totalEntries / this.limitPerPage) - 1;
    this.shownPageStart = 0;
    this.shownPageEnd = this.maxPage;

    if (this.maxPage < (this.showPagesNear + 2) * 2 + 1) {
      this.buildPages();
      return;
    }

    if (this.currentPage > this.showPagesNear + 2) {
      this.shownPageStart = this.currentPage - this.showPagesNear;
    }

    if (this.currentPage < this.maxPage - this.showPagesNear - 2) {
      this.shownPageEnd = this.currentPage + this.showPagesNear;
    }

    this.buildPages();
  }


  buildPages(): void {
    this.pages = [];

    if (this.shownPageStart > 0) {
      this.pages.push({ page: 0, text: '1' });
      this.pages.push({ page: null, text: '...' });
    }

    for (let i = this.shownPageStart; i <= this.shownPageEnd; i++) {
      this.pages.push({ page: i, text: String(i + 1) });
    }

    if (this.shownPageEnd < this.maxPage) {
      this.pages.push({ page: null, text: '...' });
      this.pages.push({ page: this.maxPage, text: String(this.maxPage + 1) });
    }
  }

  handleShowGallery(): void {
    if (!this.group.media_info) {
      return;
    }

    const gallery: MediaInfo[] = [];

    gallery.push({ ...this.group.media_info, type: this.group.media_info.is360view ? MediaType.Panorama : this.group.media_info.type });

    this.dialog.open(GalleryDialogComponent, {
      backdropClass: 'p7d-overlay-gallery-backdrop',
      panelClass: 'gallery-dialog',
      data: {
        items: gallery,
        index: 0
      }
    });
  }

}
